export enum MLBTeam {
    ARIZONA_DIAMONDBACKS = "AZ Diamondbacks",
    ATLANTA_BRAVES = "ATL Braves",
    BALTIMORE_ORIOLES = "BAL Orioles",
    BOSTON_RED_SOX = "BOS Red Sox",
    CHICAGO_CUBS = "CHI Cubs",
    CHICAGO_WHITE_SOX = "CHI White Sox",
    CINCINNATI_REDS = "CIN Reds",
    CLEVELAND_INDIANS = "CLE Indians",
    COLORADO_ROCKIES = "COL Rockies",
    DETROIT_TIGERS = "DET Tigers",
    HOUSTON_ASTROS = "HOU Astros",
    KANSAS_CITY_ROYALS = "KC Royals",
    LOS_ANGELES_ANGELS = "LA Angels",
    LOS_ANGELES_DODGERS = "LA Dodgers",
    MIAMI_MARLINS = "MIA Marlins",
    MILWAUKEE_BREWERS = "MIL Brewers",
    MINNESOTA_TWINS = "MIN Twins",
    NEW_YORK_METS = "NY Mets",
    NEW_YORK_YANKEES = "NY Yankees",
    OAKLAND_ATHLETICS = "OAK Athletics",
    PHILADELPHIA_PHILLIES = "PHI Phillies",
    PITTSBURGH_PIRATES = "PIT Pirates",
    ST_LOUIS_CARDINALS = "STL Cardinals",
    SAN_DIEGO_PADRES = "SD Padres",
    SAN_FRANCISCO_GIANTS = "SF Giants",
    SEATTLE_MARINERS = "SEA Mariners",
    TAMPA_BAY_RAYS = "TB Rays",
    TEXAS_RANGERS = "TEX Rangers",
    TORONTO_BLUE_JAYS = "TOR Blue Jays",
    WASHINGTON_NATIONALS = "WAS Nationals",
}

export enum MLBTeamColour {
    ARIZONA_DIAMONDBACKS = "#A71930",
    ATLANTA_BRAVES = "#CE1141",
    BALTIMORE_ORIOLES = "#DF4601",
    BOSTON_RED_SOX = "#BD3039",
    CHICAGO_CUBS = "#0E3386",
    CHICAGO_WHITE_SOX = "#27251F",
    CINCINNATI_REDS = "#C6011F",
    CLEVELAND_INDIANS = "#0C2340",
    COLORADO_ROCKIES = "#33006F",
    DETROIT_TIGERS = "#0C2340",
    HOUSTON_ASTROS = "#002D62",
    KANSAS_CITY_ROYALS = "#004687",
    LOS_ANGELES_ANGELS = "#BA0021",
    LOS_ANGELES_DODGERS = "#005A9C",
    MIAMI_MARLINS = "#00A3E0",
    MILWAUKEE_BREWERS = "#FFC52F",
    MINNESOTA_TWINS = "#D31145",
    NEW_YORK_METS = "#FF5910",
    NEW_YORK_YANKEES = "#003087",
    OAKLAND_ATHLETICS = "#003831",
    PHILADELPHIA_PHILLIES = "#E81828",
    PITTSBURGH_PIRATES = "#FDB827",
    ST_LOUIS_CARDINALS = "#C41E3A",
    SAN_DIEGO_PADRES = "#2F241D",
    SAN_FRANCISCO_GIANTS = "#FD5A1E",
    SEATTLE_MARINERS = "#005C5C",
    TAMPA_BAY_RAYS = "#092C5C",
    TEXAS_RANGERS = "#C0111F",
    TORONTO_BLUE_JAYS = "#134A8E",
    WASHINGTON_NATIONALS = "#AB0003",
}
